export default __webpack_public_path__ + "static/media/labMoviles_renewed.551da446.png";